
export default {
  name: 'RaiseCapitalSME',
}
